/** @jsxImportSource @emotion/react */
import React, { memo } from 'react'
import {
  ErrorMessage,
  InputContainer,
  StyledInput,
  InputWrapper,
  LeftOrnament
} from './styles'
import Typography from '@signal/components/Typography'
import withCommonSnapshotsOnly from '@signal/hoc/withCommonSnapshotsOnly'
import {
  COMMON_HEIGHTS,
  COMMON_SIZES,
  DEFAULT_SIZE
} from '@signal/theme/variables/sizes'

interface PureInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  value: string
  error?: boolean
  errorMessage?: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  $stretch?: boolean
  $height?: COMMON_SIZES
  leftOrnament?: React.ReactNode
  leftOrnamentWidth?: number
}

export const PureInput: React.FC<PureInputProps> = ({
  label,
  value,
  onChange,
  placeholder,
  leftOrnamentWidth,
  $stretch,
  $height = DEFAULT_SIZE,
  error,
  errorMessage,
  leftOrnament,
  ...props
}) => {
  const calculatedHeight = COMMON_HEIGHTS[$height]

  return (
    <InputContainer $stretch={$stretch}>
      {label && <Typography className="label">{label}</Typography>}
      <InputWrapper $height={calculatedHeight}>
        {leftOrnament && <LeftOrnament>{leftOrnament}</LeftOrnament>}
        <StyledInput
          $error={error}
          $hasLeftOrnament={!!leftOrnament}
          $leftOrnamentWidth={leftOrnamentWidth}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          {...props}
        />
      </InputWrapper>
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </InputContainer>
  )
}

export default memo(withCommonSnapshotsOnly(PureInput))
